import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { FontWeight, ellipsis } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Tooltip from "@ui-kit/tooltip";
import { tr } from "@radarly/i18n";
import { Query } from "@radarly/models/queries";

interface IProps {
  matchings: Query[];
  locale: Locale;
}

const Matchings = styled.div`
  display: flex;
`;

const Match = styled.div<{ manyMatchings?: boolean }>`
  font-weight: ${FontWeight.Bold};
  ${ellipsis()};
  max-width: ${({ manyMatchings }) => manyMatchings && "78px"};
  margin-right: ${({ manyMatchings }) => manyMatchings && "6px"};
`;

const RadarlyPostMetricsMatchings = ({ matchings, locale }: IProps) => {
  const manyMatchings = matchings.length > 1;
  return (
    <>
      {matchings.length > 0 && (
        <Tooltip
          tooltip={`${tr(locale, "POST::METRIC::MATCHING", {
            count: matchings.length,
          })}: ${map(matchings, (match) => ` ${match.label}`).join("")}`}
        >
          <div>
            <div>
              {tr(locale, "POST::METRIC::MATCHING", {
                count: matchings.length,
              })}
            </div>
            <Matchings>
              <Match manyMatchings={manyMatchings}>{matchings[0].label}</Match>
              {manyMatchings && (
                <Match manyMatchings>+{matchings.length - 1}</Match>
              )}
            </Matchings>
          </div>
        </Tooltip>
      )}
    </>
  );
};

export default RadarlyPostMetricsMatchings;
